.ux-iws-e-catalog-preloader {
    display: none;

    h4  {
        margin-bottom: 0;
    }

    p {
        max-width: 70%;
        text-align: center;
        margin: 0 auto;
        margin-top: 15px;
    }

    &__failure {
        h4 {
            margin-top: 15px;
        }
    }

    &__failure-text {
        text-align: center;

        button {
            margin-top: 15px;
        }
    }

    &__failure-icon {
        text-align: center;

        ux-icon {
            color: red;
            margin: 0 auto;
            font-size: 50px;
            text-align: center;
        }
    }
}
